// const PARTNER_BASE = "http://localhost:8080/v1/r2r/partner";

// export async function worklocation(dto) {
//   const res = await fetch(`${PARTNER_BASE}/worklocation/manual`, {
//     method: "PATCH",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(dto),
//   });
//   if(!res.ok) throw new Error("worklocation update failed");
//   return res.json();
// }

import axios from "../axiosInstance";

export const worklocation = async (dto) => {
  const res = await axios.put("/partner/worklocation/manual", dto, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

